import classNames from 'classnames'
import { debounce } from 'lodash'
import React, { useState } from 'react'
import { useLiveViewStateStore } from '../LiveViewStore'
import { setBrightnessRequest } from '../api/requests'
import { FULLSCREEN_CONTROL_WIDTH } from '../LiveViewUI'
import { Control } from './Control'
import styles from './BrightnessControls.module.css'

export const BrightnessControls: React.FC<{ fullscreen: boolean }> = ({ fullscreen }) => {
    const { liveView, setBrightness, baseURL, setLoadingBrightness, loadingBrightness } = useLiveViewStateStore()
    const [tempBrightness, setTempBrightness] = useState<number | null>(null)

    const setBrightnessAction = async (value: number) => {
        setLoadingBrightness(true)
        try {
            await setBrightnessRequest(baseURL, value)
            setLoadingBrightness(false)
        } catch (error) {
            console.log(error)
            setLoadingBrightness(false)
        }
    }

    // Debounce the brightness API request by 300ms
    const debouncedBrightnessUpdate = React.useCallback(
        debounce((value: number) => {
            setBrightnessAction(value)
        }, 300),
        [baseURL]
    )

    React.useEffect(() => {
        const brightnessChanged = tempBrightness !== null && tempBrightness === liveView.brightness
        if (brightnessChanged) {
            setTempBrightness(null)
        }
    }, [liveView.brightness])
    return (
        <div
            className={classNames(styles.root, { [styles.fullscreen]: fullscreen })}
            style={fullscreen ? { width: FULLSCREEN_CONTROL_WIDTH } : undefined}
        >
            <Control
                label="Brightness"
                min={liveView.ranges.brightness.min}
                max={liveView.ranges.brightness.max}
                step={liveView.ranges.brightness.step}
                value={tempBrightness || liveView.brightness}
                disabled={loadingBrightness}
                multipliers={[1, 2, 5]}
                setValue={(value) => {
                    setTempBrightness(value) // Update temporary state immediately
                    debouncedBrightnessUpdate(value) // Debounce API call
                }}
                fullscreen={fullscreen}
            />
        </div>
    )
}
